import {Delete} from '@mui/icons-material';
import {Box, Card, CardContent, Chip, IconButton, Typography} from '@mui/material';
import {ExamModule, UserModule} from '@cp/model';

interface CoursesSelectedModulesCardProps {
  userModule: UserModule;
  examModule: ExamModule;
  onDelete: (moduleId: string) => void;
  onClick: (moduleId: string) => void;
  deleting?: boolean;
}

export default function CoursesSelectedModulesCard({
  userModule,
  examModule,
  onDelete,
  onClick,
  deleting = false,
}: CoursesSelectedModulesCardProps) {
  if (!examModule) return null;
  return (
    <Card
      onClick={() => onClick(userModule.moduleId)}
      data-testid="selected-module-card"
      data-module-id={userModule.moduleId}
      sx={{
        height: '100%',
        position: 'relative',
        bgcolor: 'primary.main',
        color: 'white',
        cursor: 'pointer',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 6,
        },
      }}
    >
      <CardContent sx={{p: 3}}>
        <Box sx={{display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 2}}>
          <Box sx={{flex: 1}}>
            <Typography variant="h6" sx={{fontWeight: 600, mb: 1, color: 'white'}} data-testid="selected-module-name">
              {examModule.name}
            </Typography>
            <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2}}>
              <Chip
                label={examModule.level}
                size="small"
                sx={{
                  bgcolor: 'rgba(255, 255, 255, 0.2)',
                  color: 'white',
                  fontWeight: 500,
                }}
              />
              {examModule.examBoard && (
                <Chip
                  label={examModule.examBoard}
                  size="small"
                  sx={{
                    bgcolor: 'rgba(255, 255, 255, 0.2)',
                    color: 'white',
                    fontWeight: 500,
                  }}
                />
              )}
              {examModule.requiredRole && (
                <Chip
                  label={`${examModule.requiredRole}`}
                  size="small"
                  sx={{
                    bgcolor: 'rgba(255, 255, 255, 0.25)',
                    color: 'white',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                  }}
                />
              )}
            </Box>
          </Box>
          <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(userModule.moduleId);
              }}
              disabled={deleting}
              data-testid="delete-module-button"
              data-module-id={userModule.moduleId}
              sx={{
                color: 'white',
                '&:hover': {
                  bgcolor: 'rgba(255, 255, 255, 0.2)',
                },
              }}
            >
              <Delete />
            </IconButton>
          </Box>
        </Box>
        <Typography variant="body2" sx={{opacity: 0.9, color: 'white'}}>
          {examModule.topics?.length || 0} topics available
        </Typography>
      </CardContent>
    </Card>
  );
}
